module.exports = __webpack_public_path__ + "static/media/Q1_ans.e0d6b56f.png";